import type { CSSProperties } from "react";
import { createFileRoute, Link, Outlet, useRouterState } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/_auth/memberships")({
  component: MembershipsLayout,
});

function MembershipsLayout() {
  const { t } = useTranslation();
  const onStats = useRouterState({
    select: (s) => s.location.pathname.startsWith("/memberships/stats"),
  });

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      <div style={tabs}>
        <Link to="/memberships" style={{ ...tab, ...(!onStats ? tabOn : {}) }}>
          {t("memberships.tab.roster")}
        </Link>
        <Link to="/memberships/stats" style={{ ...tab, ...(onStats ? tabOn : {}) }}>
          {t("memberships.tab.stats")}
        </Link>
      </div>
      <Outlet />
    </div>
  );
}

const tabs: CSSProperties = {
  display: "inline-flex",
  gap: 6,
  padding: 4,
  borderRadius: 999,
  background: "var(--bg-inset)",
  alignSelf: "flex-start",
  fontSize: 13,
};
const tab: CSSProperties = {
  padding: "5px 16px",
  borderRadius: 999,
  textDecoration: "none",
  color: "var(--fg-mute)",
  border: "1px solid transparent",
};
const tabOn: CSSProperties = {
  background: "var(--bg)",
  color: "var(--fg)",
  border: "1px solid var(--line-soft)",
};
